import React, { useEffect, useState } from "react";
import LoadingAM from "../assets/Frame 5.gif";

export const ContactPage = () => {
  const [contactPageData, setContactPageData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
    consent: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://webadmin.naturx.co.in/api/get_extra_details",
        );
        const result = await response.json();
        if (result.status === 1) {
          setContactPageData(result.data);
        }
      } catch (error) {
        console.error("Error fetching contact details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "phone" && value.length > 10) return;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^\d{10}$/.test(formData.phone)) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }

    if (!formData.name || !formData.phone || !formData.email) {
      alert("Please fill in all required fields.");
      return;
    }

    setIsSubmitting(true);

    try {
      const queryParams = new URLSearchParams({
        name: formData.name,
        phone: formData.phone,
        email: formData.email,
        msg: formData.message,
      });

      const response = await fetch(
        `https://webadmin.naturx.co.in/api/save_contact?${queryParams.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.ok) {
        alert("Thank you! Your details have been successfully submitted.");
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
          consent: false,
        });
      } else {
        alert("There was an issue submitting the form. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred. Please check your connection and try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <div className="w-full min-h-[70vh] flex flex-col justify-center items-center gap-4">
        <img
          src={LoadingAM}
          className="w-16 h-16 object-contain"
          alt="Loading..."
        />
        <p className="text-gray-500 font-medium text-sm animate-pulse">
          Loading contact information...
        </p>
      </div>
    );
  }

  return (
    <section
      id="contact"
      className="w-full max-w-7xl mx-auto p-4 sm:p-6 lg:p-8"
    >
      {/* Header Section */}
      {/* <div className="text-left mb-6">
        <span className="text-orange-600 font-semibold tracking-wider uppercase text-sm">
          Get In Touch
        </span>
        <h1 className="text-xl sm:text-3xl font-bold text-gray-900 tracking-tight mt-1">
          Contact Us
        </h1>
        <div className="h-1 w-20 bg-orange-600 rounded mt-4 mx-0"></div>
      </div> */}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
        {/* Left Column - Details */}
        <div className="lg:col-span-5 space-y-8 bg-gray-50/80 p-4 lg:p-8 rounded-2xl border border-gray-100 shadow-sm">
          <div>
            <h2 className="text-lg lg:text-xl font-semibold text-gray-900 mb-3">
              Let's Start a Conversation
            </h2>
            <p className="text-gray-600 text-base leading-relaxed">
              NatureX Premium Textures in limecoat is a natural slaked lime and
              clay base product combined with modern application technology.
              Contact us to learn more.
            </p>
          </div>

          <div className="space-y-6 pt-4 border-t border-gray-200/60">
            {/* Email Box */}
            <div className="flex items-start gap-4 group">
              <div className="w-12 h-12 shrink-0 rounded-xl bg-orange-100 text-orange-600 flex items-center justify-center transition-transform group-hover:scale-105">
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                  Email Address
                </p>
                <a
                  href={`mailto:${contactPageData?.email || ""}`}
                  className="text-gray-900 font-medium hover:text-orange-600 transition-colors break-all"
                >
                  {contactPageData?.email || "info@naturx.co.in"}
                </a>
              </div>
            </div>

            {/* Phone Box */}
            <div className="flex items-start gap-4 group">
              <div className="w-12 h-12 shrink-0 rounded-xl bg-orange-100 text-orange-600 flex items-center justify-center transition-transform group-hover:scale-105">
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                  Phone Number
                </p>
                <a
                  href={`tel:${contactPageData?.phone || ""}`}
                  className="text-gray-900 font-medium hover:text-orange-600 transition-colors"
                >
                  {contactPageData?.phone || "+91 00000 00000"}
                </a>
              </div>
            </div>

            {/* Address Box */}
            <div className="flex items-start gap-4 group">
              <div className="w-12 h-12 shrink-0 rounded-xl bg-orange-100 text-orange-600 flex items-center justify-center transition-transform group-hover:scale-105">
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
                  Our Address
                </p>
                <a
                  href={contactPageData?.address_1_link || "#"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-900 font-medium hover:text-orange-600 transition-colors leading-relaxed block"
                >
                  {contactPageData?.address1 ||
                    "Visit our nearest office location"}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Form */}
        <div className="lg:col-span-7 bg-white p-4 sm:p-8 rounded-2xl border border-gray-100 shadow-xl shadow-gray-100/50">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Name */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Your Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:bg-white transition-all"
                  placeholder="John Doe"
                  required
                />
              </div>

              {/* Phone */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:bg-white transition-all"
                  placeholder="10-digit number"
                  pattern="\d{10}"
                  required
                />
              </div>
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Your E-mail <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:bg-white transition-all"
                placeholder="name@example.com"
                required
              />
            </div>

            {/* Message */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-2">
                Message <span className="text-red-500">*</span>
              </label>
              <textarea
                name="message"
                rows={4}
                value={formData.message}
                onChange={handleChange}
                className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:bg-white transition-all resize-none"
                placeholder="Tell us about your requirements..."
                required
              />
            </div>

            {/* Consent Checkbox */}
            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                id="consent"
                name="consent"
                checked={formData.consent}
                onChange={handleChange}
                className="w-4 h-4 mt-0.5 text-orange-600 focus:ring-orange-500 border-gray-300 rounded cursor-pointer"
                required
              />
              <label
                htmlFor="consent"
                className="text-sm text-gray-600 cursor-pointer select-none"
              >
                I consent to email tracking for a better experience and support.
              </label>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full sm:w-auto px-8 py-3.5 bg-orange-600 hover:bg-orange-700 active:bg-orange-800 text-white font-semibold rounded-xl shadow-lg shadow-orange-600/30 transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {isSubmitting ? (
                <>
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                  Sending...
                </>
              ) : (
                "Get in touch"
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
